(() => {
  const PARAM = 'filter';
  const ALL = 'all';
  const ALIASES = {
    'hobby-delight-jumbo-boxes': 'hobby',
    'hobby-boxes': 'hobby',
    'value-retail-packs': 'packs',
    'blaster-value-box': 'blaster',
    'mega-box': 'mega',
    'graded-singles': 'graded',
    'complete-sets': 'sets',
  };
  const normalize = (key) => {
    const value = (key || ALL).toLowerCase();
    return ALIASES[value] || value;
  };

  const sortSelect = document.querySelector('[data-mp-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      if (!sortSelect.value) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  const pillGroup = document.querySelector('[data-mp-filters]');
  const listing = document.querySelector('.collection-listing');
  if (!pillGroup || !listing) return;

  const status = document.querySelector('[data-mp-filter-status]');
  const pills = Array.from(pillGroup.querySelectorAll('[data-mp-filter]'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = ALL;

  const getItems = () => Array.from(listing.querySelectorAll('[data-mp-cat]'));
  const getPill = (key) => pills.find((pill) => pill.dataset.mpFilter === key);
  const isAvailable = (key) => {
    const pill = getPill(key);
    return Boolean(pill) && !pill.hidden;
  };
  const pillLabel = (pill) => pill.textContent.replace(/\s*\(\s*\d+\s*\)\s*$/, '').trim();

  function updateCounts() {
    const items = getItems();
    pills.forEach((pill) => {
      const key = pill.dataset.mpFilter;
      const count = key === ALL ? items.length : items.filter((item) => item.dataset.mpCat === key).length;
      const countEl = pill.querySelector('[data-mp-count]');
      if (countEl) countEl.textContent = count;
      if (key !== ALL) pill.hidden = count === 0;
    });
    if (!isAvailable(current)) current = ALL;
  }

  function syncUrl() {
    const url = new URL(window.location.href);
    if (current === ALL) {
      url.searchParams.delete(PARAM);
    } else {
      url.searchParams.set(PARAM, current);
    }
    if (url.toString() !== window.location.href) {
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }

  function apply(key, announce) {
    current = isAvailable(key) ? key : ALL;

    pills.forEach((pill) => {
      const active = pill.dataset.mpFilter === current;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    let visible = 0;
    getItems().forEach((item) => {
      const match = current === ALL || item.dataset.mpCat === current;
      if (match) {
        visible += 1;
        if (item.hidden && !reduceMotion.matches) item.classList.add('mp-is-revealed');
      }
      item.hidden = !match;
    });

    const empty = listing.querySelector('[data-mp-filter-empty]');
    if (empty) empty.hidden = visible > 0;

    if (announce && status) {
      const noun = visible === 1 ? 'product' : 'products';
      status.textContent = current === ALL
        ? `Showing all ${visible} ${noun}`
        : `Showing ${visible} ${noun} in ${pillLabel(getPill(current))}`;
    }
  }

  pillGroup.addEventListener('click', (evt) => {
    const pill = evt.target.closest('[data-mp-filter]');
    if (!pill || pill.hidden) return;
    apply(pill.dataset.mpFilter, true);
    syncUrl();
  });

  listing.addEventListener('click', (evt) => {
    if (!evt.target.closest('[data-mp-filter-reset]')) return;
    apply(ALL, true);
    syncUrl();
    const allPill = getPill(ALL);
    if (allPill) allPill.focus();
  });

  listing.addEventListener('animationend', (evt) => {
    if (evt.animationName === 'mp-filter-in') evt.target.classList.remove('mp-is-revealed');
  });

  // Symmetry's ajax filtering/sorting replaces the grid and pushes a URL without our param.
  new MutationObserver(() => {
    updateCounts();
    apply(current, false);
    syncUrl();
  }).observe(listing, { childList: true });

  updateCounts();
  apply(normalize(new URL(window.location.href).searchParams.get(PARAM)), false);
  syncUrl();
})();
